import { ApiFunc, getInstance, getNotAuthInstance } from '@src/helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

export const vacationList: ApiFunc<`${typeof API.VACATION_REQUEST}`, 'get'> = data =>
  instance.get(API.VACATION_REQUEST, { params: data })

export const vacationCreate: ApiFunc<`${typeof API.VACATION_REQUEST}`, 'post'> = data =>
  instance.post(API.VACATION_REQUEST, data)

export const vacationDelete: ApiFunc<`${typeof API.VACATION_REQUEST}{id}`, 'delete'> = data =>
  instance.delete(`${API.VACATION_REQUEST}${'id' in data ? data.id : data.name}`)

export const vacationDownload: ApiFunc<`${typeof API.VACATION_REQUEST_DOWNLOAD}`, 'get'> = data =>
  instance.get(API.VACATION_REQUEST_DOWNLOAD, { params: data })

export const vacationStatus: ApiFunc<`${typeof API.VACATION_REQUEST_STATUS}`, 'post'> = data =>
  instance.post(API.VACATION_REQUEST_STATUS, data)

export const vacationPublicInfo: ApiFunc<`${typeof API.VACATION_PUBLIC_INFO}`, 'get'> = data =>
  getNotAuthInstance().get(API.VACATION_PUBLIC_INFO, { params: data })
